<template>
  <b-container class="">
    <b-row align-h="end" align-v="end">
      <b-form class="justify-content-end" inline @submit.prevent="refresh">
        <b-form-group label-class="font-weight-normal m-1">
          <b-form-select v-model="filters.provider" :options="providers" class="w-100 cursor-pointer"
            value-field="value" text-field="label" size="sm"></b-form-select>
        </b-form-group>
        <b-form-group>
          <b-form-datepicker class="m-1" size="sm" placeholder="From" hide-header v-model="filters.dates.from"
            :max="today" :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            }" />
        </b-form-group>
        <b-form-group>
          <b-form-datepicker class="m-1" size="sm" placeholder="To" hide-header v-model="filters.dates.to"
            :min="filters.dates.from" :max="today" required :date-format-options="{
              year: 'numeric',
              month: 'long',
              day: '2-digit',
            }" />
        </b-form-group>
        <b-row class="flex-nowrap" no-gutters>
          <b-button block class="m-1" type="submit" variant="dark" size="sm">
            Refresh
          </b-button>
        </b-row>
      </b-form>
    </b-row>
    <b-row align-h="center" class="mt-2">
      <transition name="component-fade" mode="out-in">
        <Line-Loader v-if="state.loading" />
      </transition>
      <transition-group name="component-group-fade" mode="out-in" class="w-100">
        <b-container class="p-5 py-0 bg-light br-5" key="1" v-if="balances.length < 1">
          <transition-group name="component-group-fade" mode="out-in">
            <p class="text-center" key="1" v-show="state.loading">
              Loading Daily Closing Balance...
            </p>
            <p class="text-center" key="2" v-show="!state.loading">
              Daily Closing balance are not available.
            </p>
          </transition-group>
        </b-container>
        <b-container key="2" v-else>
          <b-row>
            <b-table-simple :table-class="state.loading ? 'table-busy' : ''" key="table" hover small responsive
              bordered>
              <b-thead class="br-10">
                <b-tr variant="light">
                  <b-th class="text-center">Date</b-th>
                  <b-th class="text-center">Mtn-Balance</b-th>
                  <b-th class="text-center">Airtel-Cash-in</b-th>
                  <b-th class="text-center px-2">Airtel-Cash-out</b-th>
                </b-tr>
              </b-thead>
              <b-tbody style="font-size: 15px">
                <b-tr v-for="(tranx, i) in balances" :key="i">
                  <b-td class="text-center">
                    {{ tranx.created_at | date }}
                  </b-td>
                  <b-td class="text-center px-2">
                    {{ tranx.mtn_balance | currency }}
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.airtel_balance | currency }} Rwf
                  </b-td>
                  <b-td class="text-right px-2">
                    {{ tranx.airtel_cashout_balance | currency }} Rwf
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-pagination size="sm" @input="pageChanged" v-model="pagination.currentPage"
              :total-rows="pagination.totalRows" :per-page="pagination.perPage" pills align="center"
              v-if="showPagination"></b-pagination>
          </b-row>
        </b-container>
      </transition-group>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
export default {
  props: ["merchant"],
  data() {
    let dates = {
      from: moment().subtract(1, "months").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    };
    return {
      state: { loading: false },
      from: dates.from,
      to: dates.to,
      balances: [],
      filters: {
        merchant: null,
        dates,
        provider: "all",
      },
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 50,
        offset: 0,
      },
      providers: [
        { label: "All", value: "all" },
        { label: "MTN", value: "mtn" },
        { label: "AIRTEL Cashin's", value: "airtel_cashin" },
        { label: "AIRTEL Cashout", value: "airtel_cashout" },
      ],
    };
  },
  computed: {
    today() {
      return moment().toDate();
    },
    showPagination() {
      return this.pagination.totalRows > this.pagination.perPage;
    },
  },
  filters: {
    date: (date) => {
      if (!moment.isDate(new Date(date))) return date;
      return moment(new Date(date)).format("DD-MM-YYYY");
    },
    currency: (num) => Number(num).toLocaleString('en-US'),
  },
  mounted() {
    this.fetchDailyCloseBalances();
  },
  methods: {
    startOfDay(date) {
      return moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    },
    endOfDay(date) {
      return moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
    },
    async fetchDailyCloseBalances() {
      if (this.state.loading) return;
      this.state.loading = true;
      try {
        const reqData = {
          from: this.startOfDay(this.filters.dates.from),
          to: this.endOfDay(this.filters.dates.to),
          merchant: this.merchant.id,
          offset: this.pagination.offset,
          limit: this.pagination.perPage,
        };
        if (this.filters.provider !== "all") reqData.provider = this.filters.provider;
        const queryString = this.$getQueryString(reqData);
        const { data } = await this.axios(
          `internal/balances/daily-closing?${queryString}`
        );
        if (Array.isArray(data.balances)) {
          this.$set(this.pagination, "totalRows", data.total);
          this.$set(this, "balances", data.balances);
        }
      } catch (error) {
        if (error.errorMessage) {
          if (Array.isArray(error.errorMessage))
            this.$notify(error.errorMessage[0], "error");
          else this.$notify(error.errorMessage, "error");
        } else {
          this.$notify("Something went wrong", "error");
        }
      } finally {
        this.state.loading = false;
      }
    },
    refresh() {
      this.fetchDailyCloseBalances();
    },
    pageChanged(page) {
      const { perPage } = this.pagination;
      this.$nextTick(() => {
        this.$set(this.pagination, "offset", perPage * (page - 1));
        this.$set(this.pagination, "currentPage", page);
        this.refresh();
      });
    },
    resetPage() {
      this.$nextTick(() => {
        this.$set(this.filters.dates, "from", null);
        this.$set(this.filters.dates, "to", null);
        this.$set(this.filters, "merchant", null);
        this.$set(this.filters, "provider", "all");
        this.resetPagination();
      });
    },
    resetPagination() {
      this.$nextTick(() => {
        this.$set(this.pagination, "totalRows", 0);
        this.$set(this.pagination, "offset", 0);
        this.$set(this.pagination, "currentPage", 1);
      });
    },
  },
};
</script>

<style></style>
